module.exports = __webpack_public_path__ + "4ef44c24ad6e4abd1cabd44d2ad0108f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-hourglass.png
// module id = 2080
// module chunks = 4